module.exports = __webpack_public_path__ + "media/images/vacances-ete-d-2443a35ba4ac764917eb2eec06858b92.jpg";